import React from 'react';
import Header from '../components/Header';
import HeroWithForm from '../components/HeroWithForm';
import StatsSection from '../components/StatsSection';
import BrandLogosSection from '../components/BrandLogosSection';
import AboutSection from '../components/AboutSection';
import GallerySection from '../components/GallerySection';
import TestimonialsSection from '../components/TestimonialsSection';
import LocationSection from '../components/LocationSection';
import FinalCTA from '../components/FinalCTA';
import ImportantNotice from '../components/ImportantNotice';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroWithForm />
      <StatsSection />
      <BrandLogosSection />
      <AboutSection />
      <GallerySection />
      <TestimonialsSection />
      <LocationSection />
      <FinalCTA />
      <ImportantNotice />
      <Footer />
    </div>
  );
};

export default Home;
